module.exports = __webpack_public_path__ + "static/scale-model-of-denver-botanic-gardens-in-denver-colorado-73782116c065fc947b40023e3c404ac4.png";